export default __webpack_public_path__ + "static/media/mobile-no.a1f667a7.svg";